/**
 * en-GB messages added by Phase 3 task S27 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s27EnGB = {
    'nav.events': 'Events',
    'error.event_ends_before_start': 'The event must end after it starts.',
    'error.event_not_deletable': 'A published event is kept for its attendance record. Cancel it first.',
    'error.attendee_duplicate': 'That person is already on the list for this event.',
    'events.annotation.attendee': 'Event: {event}',
};
//# sourceMappingURL=s27.js.map